<app-multi-select-input
    [(value)]="value"
    [id]="id()"
    [label]="label()"
    [errors]="errors()"
    [touched]="touched()"
    [disabled]="disabled()"
    [readonly]="readonly()"
    [invalid]="invalid()"
    [required]="required()"
    [attributes]="attributes()"
    [size]="size()"
    [helpText]="helpText()"
    [appendTo]="appendTo()"
    [zIndex]="zIndex()"
    [showClear]="showClear()"
    [infiniteScroll]="userScroll()"
    valueKey="id"
    labelKey="name"
    filterBy="name,surname,id,email,icpOfDoctor"
    (touch)="touch.emit()"
>
    <ng-template #item let-item>
        <div class="flex-column gap-xx-small">
            <div>{{ item | formatPerson }}</div>
            @if (item.email) {
                <div class="font-size-x-small text-secondary">
                    {{ item.email }}
                </div>
            }
            @if (item.icpOfDoctor) {
                <div class="font-size-x-small text-secondary">
                    {{ item.icpOfDoctor }}
                </div>
            }
        </div>
    </ng-template>
    <ng-template #selectedItems let-items>
        @if (items?.length > selectedUsersDisplayLimit()) {
            {{ 'common.selectedItems' | translate: { count: items.length } }}
        } @else {
            <div class="flex gap-small flex-wrap">
                @for (item of items; track item.id) {
                    <app-user-chip
                        [user]="item"
                        [renderDetails]="false"
                        [renderType]="UserChipRenderTypeEnum.User"
                    ></app-user-chip>
                }
            </div>
        }
    </ng-template>
</app-multi-select-input>
